
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/eventi/[slug]/servizi/la-villa",
      function () {
        return require("private-next-pages/stores/eventi/[slug]/servizi/la-villa.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/eventi/[slug]/servizi/la-villa"])
      });
    }
  